import * as React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { DialogContent, Stack } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

export type CustomAlertDialogProps = DialogProps & {
  open: boolean;
  children?: React.ReactNode;
  heading: string;
  useFullWidth?: boolean;
  leftButtonHeading?: string;
  middleButtonHeading?: string;
  rightButtonHeading: string;
  leftButtonDisabled?: boolean;
  rightButtonDisabled?: boolean;
  handleClosePressed: () => void;
  middleButtonPressed?: () => void;
  handleCancel: () => void;
  sx?: SxProps<Theme>;
  textCentre?: boolean;
};

export const CustomDialog = (props: CustomAlertDialogProps) => {
  const {
    open,
    heading,
    handleClosePressed,
    middleButtonPressed,
    handleCancel,
    children,
    leftButtonHeading,
    middleButtonHeading,
    rightButtonHeading,
    rightButtonDisabled = false,
    leftButtonDisabled = false,
    sx,
    textCentre,
    ...others
  } = props;
  const [openDialog, setOpenDialog] = React.useState(open);

  React.useEffect(() => {
    setOpenDialog(open);
  }, [open]);

  const handleClose = () => {
    handleClosePressed();
  };

  const handleCancelPressed = () => {
    handleCancel();
  };

  return (
    <Stack id="CustomDialog" sx={[...(Array.isArray(sx) ? sx : [sx])]}>
      <Dialog
        open={openDialog}
        onClose={handleCancelPressed}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...others}
      >
        <DialogTitle textAlign={textCentre ? "center" : "left"} id="alert-dialog-title">
          {heading}
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {leftButtonHeading && (
            <Button color="primary" onClick={handleCancelPressed} disabled={leftButtonDisabled}>
              {leftButtonHeading}
            </Button>
          )}
          {middleButtonHeading && (
            <Button color="primary" variant="outlined" onClick={middleButtonPressed}>
              {middleButtonHeading}
            </Button>
          )}
          {rightButtonHeading && (
            <Button color="primary" variant="contained" onClick={handleClose} disabled={rightButtonDisabled}>
              {rightButtonHeading}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Stack>
  );
};
export default CustomDialog;
